import React from 'react'
import { Link } from 'react-router-dom'
import AutoTable from 'components/AutoTable'
import { Alert } from 'reactstrap'
import { Site } from 'types'

interface SitesResultsGridProps {
  sites: Site[]
}

const SitesResultsGrid: React.FC<SitesResultsGridProps> = ({ sites }) => {
  const columns = [
    {
      title: 'Site Name',
      fieldValue: 'name',
    },
    {
      title: 'NetSuite Customer Id',
      fieldValue: 'netSuiteCustomer.nsCustomerId',
    },
    {
      title: 'Organization Name',
      fieldValue: 'organization.name',
    },
    {
      title: 'Organization Id',
      fieldValue: 'organization.id',
    },
    {
      title: 'Site Id',
      fieldValue: (row: any) => {
        return <Link to={`/css-admin/sites/${row.id}`}>{row.id}</Link>
      },
      sortValue: 'id',
      filterValue: 'id',
    },
  ]

  return sites.length > 0 ? (
    <AutoTable
      borderless
      columns={columns}
      filter
      headThemeLight
      rows={sites}
      sort
    />
  ) : (
    <Alert color="warning">No results found</Alert>
  )
}

export default SitesResultsGrid
